<template>
  <div id="eventTrackingErrorsSummaryPage">
    <!-- Page Header -->
    <div class="pageHeader">
      <div class="headerContent">
        <div>
          <span class="pageTitle">Event Sync Errors</span>
          <div class="text-gray-500 text-sm">Details of errors occured during syncing data from apis or sdks.</div>
        </div>
        <div class="float-right">
          <el-select v-model="timingFilter" size="small" class="w-48">
            <el-option-group v-for="group in eventTrackingErrorsTimingOptions" :key="group.label" :label="group.label">
              <el-option v-for="item in group.options" :key="item.value" :label="item.title" :value="item.value"> </el-option>
            </el-option-group>
          </el-select>
          <el-date-picker class="w-20 mt-2" size="small" :editable="false" start-placeholder="Start Date" end-placeholder="End Date" :clearable="false" v-if="timingFilter == 'custom'" v-model="customTimeRange" type="daterange" format="dd-MMM-yyyy" @change="onDateRangeChange"> </el-date-picker>
          <div v-if="displayTimeRange && timingFilter != 'custom' && !fetchingData" class="text-right text-xs text-gray-400 py-1">
            {{ displayTimeRange.start + ' - ' + displayTimeRange.end }}
          </div>
        </div>
      </div>

      <!-- Summary Cards -->
      <el-row :gutter="20" v-if="summaryData" class="summaryCards">
        <el-col :span="12">
          <div class="statCard">
            <div class="statCardTitle">Total Errors</div>
            <div class="statCardValue">{{ getNumberWithComma(summaryData.totalCount) }}</div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="statCard">
            <div class="statCardTitle">Affected Events</div>
            <div class="statCardValue">{{ summaryData.eventwiseCountArr ? summaryData.eventwiseCountArr.length : 0 }}</div>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- Error Trend Chart Card -->
    <el-card class="chartCard" shadow="never" v-loading="fetchingData">
      <div slot="header" class="chartHeader">
        <span>Error Trend (Daily)</span>
      </div>
      <div v-if="!fetchingData && chartOptions">
        <highcharts :options="chartOptions"></highcharts>
      </div>
      <div v-else-if="!fetchingData" class="noDataDiv">
        <i class="fa fa-bar-chart"></i>
        <div>No error data available for the selected date range</div>
      </div>
    </el-card>

    <!-- Event-wise Error Table Card -->
    <el-card class="tableCard" shadow="never" v-loading="fetchingData">
      <div slot="header" class="tableHeader">
        <span>Event-wise Errors</span>
      </div>
      <el-table v-if="!fetchingData && summaryData && summaryData.eventwiseCountArr" :data="summaryData.eventwiseCountArr" style="width: 100%" @row-click="onEventRowClick">
        <el-table-column prop="event" label="Event Name" min-width="200">
          <template slot-scope="scope">
            <el-button type="text" style="padding: 0px">
              {{ scope.row.event }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="count" label="Error Count" width="150" align="center">
          <template slot-scope="scope">
            {{ getNumberWithComma(scope.row.count) }}
          </template>
        </el-table-column>
      </el-table>
      <div v-else-if="!fetchingData" class="noDataDiv">
        <i class="fa fa-table"></i>
        <div>No event errors available for the selected date range</div>
      </div>
    </el-card>
  </div>
</template>

<style lang="scss" src="./eventTrackingErrorsSummary.scss"></style>

<script>
import eventTrackingErrorsSummaryComponent from './eventTrackingErrorsSummaryComponent';
export default eventTrackingErrorsSummaryComponent;
</script>
